import { getActionTypesForService } from 'shared/utils/createServiceStore.js';
import { API_KEY_SERVICE_KEY } from './apiKeyEnum.js';

export default getActionTypesForService(API_KEY_SERVICE_KEY);
